import React, {useState, useEffect} from "react";
import {connect} from "react-redux";
import axios from "axios";
import {serverLink} from "../../resources/url";
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import {setApplicationDetails, setGeneralDetails, setLoginDetails} from "../../actions/actions";
import Header from "../common/header/header";
import Sidebar from "../common/sidebar/sidebar";
function GuardianInfo(props) {
    const navigate = useNavigate();
    const [userData] = useState(props.applicationLogin);
    const [isFormLoading, setisFormLoading] = useState('off')
    const [guardianData, setGuardianData] = useState(
        props.applicant_data.guardian
    );
    const [guardian, setGuardian] = useState({
        ApplicationID: props.applicationData.EntryID,
        FirstName: "",
        MiddleName: "",
        Surname: "",
        PhoneNumber: "",
        EmailAddress: "",
        Address: "",
        Gender: "",
        EntryID: ""
    });

    const [shouldSave, setShouldSave] = useState(false);

    const handleChange = (e) => {
        setGuardian({ ...guardian, [e.target.id]: e.target.value });
        setShouldSave(true);
    };

    const allApplicationData = async () => {
        await axios
            .get(
                `${serverLink}application/ug/application/data/${props.applicationData.EntryID}`
            )
            .then((response) => {
                props.setOnGeneralDetails(response.data);
                setGuardianData(response.data.guardian);
                if (response.data.guardian.length > 0) {
                    setGuardian(response.data.guardian[0])
                    setShouldSave(true)
                }

            })
            .catch((error) => {
                console.log(error);
            });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        for (let value in guardian) {
            if (guardian.hasOwnProperty(value) && value !== "MiddleName" && guardian.hasOwnProperty(value) && value !== "EntryID") {
                if (guardian[value] === "") {
                    toast.error(`${value} can't be empty`);
                    return false;
                }
            }
        }

        if (userData.EmailAddress === guardian.EmailAddress) {
            toast.error("please provide a correct guardian email")
            return false
        }
        if (userData.PhoneNumber.trim() === guardian.PhoneNumber.trim()) {
            toast.error("please provide a correct guardian phone number")
            return false
        }

        if (shouldSave) {
            setisFormLoading('on')
            toast.info(`Submitting... Please wait!`);
            if (guardian.EntryID === "") {
                await axios
                    .post(`${serverLink}application/guardian/info`, guardian)
                    .then((res) => {
                        if (res.data.message === "success") {
                            toast.success(`Guardian Information Submitted Successfully`);
                            allApplicationData();
                            onNext();
                            setisFormLoading('off')
                        } else
                            toast.error(
                                `Something went wrong. Please check your connection and try again!`
                            );
                        setisFormLoading('off')
                    })
                    .catch((error) => {
                        console.log("NETWORK ERROR", error);
                    });
            } else {
                setisFormLoading('on')
                await axios
                    .patch(`${serverLink}application/guardian/update/info`, guardian)
                    .then((res) => {
                        if (res.data.message === "success") {
                            toast.success(`Guardian Information Submitted Successfully`);
                            allApplicationData();
                            onNext();
                            setisFormLoading('off')
                        } else
                            toast.error(
                                `Something went wrong. Please check your connection and try again!`
                            );
                        setisFormLoading('off')
                    })
                    .catch((error) => {
                        console.log("NETWORK ERROR", error);
                    });
            }
        }
    };

    const onPrevious = () => {
        navigate("/undergraduate/jamb-result");
    };

    const onNext = () => {
        navigate("/undergraduate/document-uploads");
    };

    useEffect(() => {
        allApplicationData();
    }, [])

    useEffect(() => {
        if (props.applicationLogin.length === 0) {
            navigate("/login");
        }
    }, [props.applicationLogin])

    return (
        // loading ?
        //     <Loader/>
        //     :
        <>
            <div className="main-wrapper">
                <Header/>
                <Sidebar/>
                <div className="page-wrapper">
                    <div className="content">
            <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
                <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
                    <div className="my-auto mb-2">
                        <h3 className="page-title mb-1">Welcome, {`${userData.FirstName} ${userData.MiddleName} ${userData.Surname}`
                        }</h3>
                        <nav>
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item">
                                    <a href="">Dashboard</a>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">Guardian Information</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <div className="row justify-content-center mt-3" style={{marginTop:"-40px"}}>
                <div className="col-md-10 d-flex justify-content-center align-items-center min-vh-40">
                    <div className="flex-fill">
                        <br />
                        <form className="login bg-white shadow p-5" onSubmit={handleSubmit}>
                            <h3><b>Guardian Information</b></h3>
                            <br/>
                            <div className="row col-md-12">
                                <div className="col-md-6 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="FirstName" className="form-label">
                                            First Name <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            id="FirstName"
                                            className="form-control"
                                            placeholder="First Name"
                                            value={guardian.FirstName}
                                            // required
                                            onChange={handleChange}
                                        />
                                        <span className="focus-border" />
                                    </div>
                                </div>

                                <div className="col-lg-6">
                                    <div className="form-group">
                                        <label htmlFor="MiddleName" className="form-label">Middle Name</label>
                                        <input
                                            type="text"
                                            id="MiddleName"
                                            className="form-control"
                                            placeholder="Middle Name"
                                            value={guardian.MiddleName}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="Surname" className="form-label">
                                            Last Name <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            id="Surname"
                                            value={guardian.Surname}
                                            className="form-control"
                                            placeholder="Last Name"
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="PhoneNumber" className="form-label">
                                            Phone Number <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="tel"
                                            id="PhoneNumber"
                                            value={guardian.PhoneNumber}
                                            className="form-control"
                                            placeholder="Phone Number"
                                            // required
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="EmailAddress" className="form-label">
                                            Email <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="email"
                                            id="EmailAddress"
                                            value={guardian.EmailAddress}
                                            className="form-control"
                                            placeholder="Email Address"
                                            // required
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6 ">
                                    <div className="form-group">
                                        <label htmlFor="Gender" className="form-label">
                                            Gender <span className="text-danger">*</span>
                                        </label>
                                        <select
                                            id="Gender"
                                            className="form-control"
                                            value={guardian.Gender}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select Option</option>
                                            <option value="Male">Male</option>
                                            <option value="Female">Female</option>
                                            <option value="Other">Other</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-12 mt-3 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="Address" className="form-label">
                                            Address <span className="text-danger">*</span>
                                        </label>
                                        <textarea
                                            id="Address"
                                            className="form-control"
                                            placeholder="Address"
                                            defaultValue={guardian.Address}
                                            rows="3"
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    {isFormLoading === 'on' ?
                                        <button className="btn btn-dark text-center offset-3 w-50" id="kt_modal_new_address_submit">
                                                    <span className="indicator-progress">Please wait...
                                                    <span className="spinner-border spinner-border-sm align-middle ms-2" />
                                                </span>
                                        </button>
                                        :
                                        <div className="filters-group mb-lg-4 text-center">
                                            <button className="btn btn-dark mx-3 active" onClick={onPrevious}> Previous</button>
                                            <button className="btn btn-dark w-50  active" type="submit">  Save and Continue</button>
                                        </div>
                                    }
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
</div>
</div>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        applicationLogin: state.loginDetails,
        applicationData: state.applicationDetails,
        applicant_data: state.generalDetails,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setOnLoginDetails: (p) => {
            dispatch(setLoginDetails(p));
        },
        setOnGeneralDetails: (p) => {
            dispatch(setGeneralDetails(p));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(GuardianInfo);
